<!-- kontakti.component.html -->
<div class="grid-section">
  <div class="toolbar">
    <dx-button
      icon="refresh"
      text="Osvježi"
      type="default"
      (onClick)="onRefreshClick()">
    </dx-button>
  </div>

  <dx-data-grid
    #kontaktiGrid
    id="kontaktiGrid"
    keyExpr="id"
    [dataSource]="gridData"
    [showBorders]="true"
    [allowColumnResizing]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [hoverStateEnabled]="true"
    [filterRow]="{ visible: true }"
    [searchPanel]="{ visible: true }"
    [paging]="{ pageSize: 50 }"
    [pager]="{
      showPageSizeSelector: true,
      allowedPageSizes: [10, 20, 50, 100],
      showInfo: true
    }"
    [rowAlternationEnabled]="true">
    
    <dxi-column 
      dataField="imeFirme" 
      caption="Firma" 
      [minWidth]="200"
      [allowFiltering]="true"
      [allowSearch]="true">
    </dxi-column>
    
    <dxi-column 
      dataField="email" 
      caption="Email" 
      [minWidth]="200"
      [allowFiltering]="true"
      [allowSearch]="true">
    </dxi-column>
    
    <dxi-column 
      dataField="poruka" 
      caption="Poruka" 
      [minWidth]="300"
      [allowFiltering]="true"
      [allowSearch]="true">
    </dxi-column>
    
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
  </dx-data-grid>
</div>

<dx-load-panel
  [position]="loadPanelPosition"
  [visible]="loading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>